import { useRef, useState } from "react";
import { Accordion, Form, ListGroup } from "react-bootstrap";
import postal from 'postal'

export default function AddressSearchToolbox(props) {

    const [value, setValue] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const sessionTokenRef = useRef(null);
    const debounceRef = useRef(null);

    const getSessionToken = () => {
        if (!sessionTokenRef.current) {
            sessionTokenRef.current = new window.google.maps.places.AutocompleteSessionToken();
        }
        return sessionTokenRef.current;
    };

    const handleInputChange = (e) => {
        const input = e.target.value;
        setValue(input);

        clearTimeout(debounceRef.current);

        if (!input) {
            setSuggestions([]);
            return;
        }

        debounceRef.current = setTimeout(async () => {
            const { suggestions } = await window.google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
                input,
                sessionToken: getSessionToken()
            });
            setSuggestions(suggestions ?? []);
        }, 200);
    };

    const handleSelect = async (suggestion) => {
        const place = suggestion.placePrediction.toPlace();
        await place.fetchFields({ fields: ["location"] });

        if (place?.location) {
            postal.publish({
                channel: "map",
                topic: "view.change",
                data: {
                    lat: place.location.lat(),
                    lng: place.location.lng()
                }
            });
        }

        setValue("");
        setSuggestions([]);
        sessionTokenRef.current = null;
    };

    return <Accordion.Item eventKey='0'>
        <Accordion.Header><i className='fi-map-pin me-2' /> Address Search</Accordion.Header>
        <Accordion.Body>
            <div style={{ position: "relative" }}>
                <Form.Control
                    value={value}
                    onChange={handleInputChange}
                    onBlur={() => setTimeout(() => setSuggestions([]), 150)}
                    placeholder="Enter a location"
                />
                {suggestions.length > 0 && (
                    <ListGroup style={{ position: "absolute", width: "100%", zIndex: 1000, backgroundColor: "#fff" }}>
                        {suggestions.map((suggestion, index) => (
                            <ListGroup.Item
                                key={index}
                                action
                                onMouseDown={() => handleSelect(suggestion)}
                            >
                                {suggestion.placePrediction.text.text}
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                )}
            </div>
        </Accordion.Body>
    </Accordion.Item>

}
